module.exports = __webpack_public_path__ + "fonts/iconfont.f7e4a177.woff";